var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative", staticStyle: { position: "relative" } },
    [
      _c(
        "div",
        { ref: "slider", staticClass: "keen-slider", class: _vm.classes },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.slider && _vm.hasArrows
        ? [
            _c(
              "button",
              {
                class: {
                  "keen-slider__arrow": true,
                  "keen-slider__arrow--left": true,
                  "keen-slider__arrow--disabled": _vm.current === 0,
                  "turn-on": _vm.arrowsTurnOn,
                  "turn-off": !_vm.arrowsTurnOn,
                },
                attrs: { "aria-label": "Previous" },
                on: {
                  click: function ($event) {
                    return _vm.slider.prev()
                  },
                },
              },
              [_c("span", { staticClass: "icon-chevron-left" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: {
                  "keen-slider__arrow": true,
                  "keen-slider__arrow--right": true,
                  "keen-slider__arrow--disabled": _vm.isLastSlide,
                  "turn-on": _vm.arrowsTurnOn,
                  "turn-off": !_vm.arrowsTurnOn,
                },
                attrs: { "aria-label": "Next" },
                on: {
                  click: function ($event) {
                    return _vm.slider.next()
                  },
                },
              },
              [_c("span", { staticClass: "icon-chevron-right" })]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.slider && _vm.hasPagination
        ? _c(
            "div",
            { staticClass: "keen-slider__pagination" },
            _vm._l(_vm.dotHelper, function (_slide, idx) {
              return _c("button", {
                key: idx,
                class: { dot: true, "dot--active": _vm.current === idx },
                attrs: { "aria-label": "Go to slide " + (idx + 1) },
                on: {
                  click: function ($event) {
                    return _vm.slider.moveToIdx(idx)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }